<template>
  <div style="float: right;" @click="click">
    <inline-svg :fill="cor" :src="require('@/assets/icons/Arrow_chevron.svg')" class="arrow"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import inlineSvg from 'vue-inline-svg'
export default {
  props: ['column', 'row'],
  components: { inlineSvg },
  computed: {
    ...mapGetters('SetupApp', [ 'estilo' ]),
    cor () {
      if (!this.estilo.aplicacao) {
        return ''
      }
      return this.estilo.aplicacao.corPrimariaAplicacao
    }
  },
  methods: {
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
